import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://pickleball-ready.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get the Pickleball Ready™ Pack',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  return <a href={href} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group mt-2.5 inline-flex items-center justify-center gap-3 rounded-full bg-brand px-9 py-6 text-center text-sm font-extrabold uppercase leading-none text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-brand-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:text-base ${className}`} data-id="element-40" data-mp="qk1zz2w5dedf">
      <span className="-mr-[0.12em] tracking-[0.12em]" data-id="element-41" data-mp="15arjcsjrhzsd">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-42" data-mp="35xo3t6jumop6" />
    </a>;
}